import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getErrorCode, getErrorStatusCode } from "../../../../../api/api-response";
import { RestEndpoints } from "../../../../../api/endpoints";
import getInstance from "../../../../../utils/rest";
import { CfmQueryKeys } from "../../cfm-query-keys";

const updateCfmProductActive = async (productId: number, isActive: boolean): Promise<void> => {
  const url = RestEndpoints.UpdateCfmProductActive.replace(":id", productId.toString());
  await getInstance().patch(url, {
    isActive,
  });
};

export const useUpdateCfmProductActiveQuery = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ productId, isActive }: { productId: number; isActive: boolean }) => updateCfmProductActive(productId, isActive),

    onError: (error) => {
      const errorMsg = getErrorCode(error);
      const errorCode = getErrorStatusCode(error);
      enqueueSnackbar(t("general.error_occurred", { errorCode, errorMsg }), { variant: "error" });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CfmQueryKeys.GetAllProductsInfinite] });
      queryClient.invalidateQueries({ queryKey: [CfmQueryKeys.GetProductCount] });
      queryClient.invalidateQueries({ queryKey: [CfmQueryKeys.GetProductStates] });
      queryClient.invalidateQueries({ queryKey: [CfmQueryKeys.GetProductFractions] });
      queryClient.invalidateQueries({ queryKey: [CfmQueryKeys.GetProductTypes] });
      queryClient.invalidateQueries({ queryKey: [CfmQueryKeys.GetProductCategories] });
      enqueueSnackbar(t("general.successfull_saved"), { variant: "success" });
    },
  });
};
